import React, { useState } from 'react'
import { Link, navigate } from 'gatsby'
import Modal from 'react-modal'

const CtaButton = ({ text, url, customClass, newWindow }) => {
  const openLightBoxKeywords = ['upsales']
  const [showLightbox, setShowLightbox] = useState(false)

  const internal = /^\/(?!\/)/.test(url)

  const handleExternalLinkClick = (e) => {
    if (openLightBoxKeywords.some((keyword) => url.includes(keyword))) {
      e.preventDefault()
      navigate('#')
      setShowLightbox(true)
    }
  }

  const closeButtonStyles = {
    position: 'absolute',
    top: '1.5rem',
    right: '1rem',
    background: 'transparent',
    border: 'none',
  }

  return (
    <>
      {internal ? (
        <Link to={url} className={`button mt-4 ${customClass}`}>
          {text}
        </Link>
      ) : (
        <>
          <a
            href={url}
            onClick={handleExternalLinkClick}
            target={newWindow && !url.includes('upsales') ? `_blank` : null}
            rel={newWindow ? 'noopener noreferrer' : null}
            className={`button mt-4 ${customClass}`}
          >
            {text}
          </a>
          <Modal
            isOpen={showLightbox}
            onRequestClose={() => setShowLightbox(false)}
            contentLabel="Lightbox Modal"
            style={{
              overlay: { top: '50px', padding: '0', zIndex: 1000 },
              content: { padding: '0', inset: '15px' },
            }}
          >
            <iframe
              src={url}
              title="Lightbox Content"
              width="100%"
              height="100%"
            ></iframe>
            <button
              className="is-family-secondary is-size-4"
              style={closeButtonStyles}
              onClick={() => setShowLightbox(false)}
            >
              x
            </button>
          </Modal>
        </>
      )}
    </>
  )
}

export default CtaButton
